<template>
  <b-card header-tag="header" footer-tag="footer" style="max-height: 1160px; overflow-y: auto;">
    <template #header>
      <h6>Historial</h6>
    </template>
    <b-card-text text-tag="div">
      <b-alert v-if="errors.length > 0" variant="danger" show>
        <ul style="list-style-type: none;">
          <li v-for="(e, i) in errors" :key="i">{{e.message}}</li>
        </ul>
      </b-alert>
      <Loading :active="loading" :is-full-page="false"></Loading>
      <b-card
        v-for="(item, i) in items"
        :key="i"
        :header-bg-variant="item.style"
        class="mb-2"
      >
        <template #header>
          <h6 class="mb-0">{{item.title}}</h6>
        </template>
        <b-card-text>
          {{item.message}}
        </b-card-text>
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th>Campo</th>
                <th>Antes</th>
                <th>Despues</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(field, j) in item.data.fields" :key="j">
                <td>{{getFieldText(j)}}</td>
                <td>{{field.old}}</td>
                <td>{{field.new}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="text-primary">
          <font-awesome-icon :icon="['fas', 'user']"/> {{item.data.user.name}} <br>
          <font-awesome-icon :icon="['fas', 'calendar']"/> {{ $moment(item.created_at).format('YYYY-MM-DD HH:mm:ss') }}</p>
      </b-card>
      <!-- <b-table :items="items" :fields="fields"></b-table> -->
    </b-card-text>
  </b-card>
</template>
<script>
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  export default {
    name:'ReservationHitory',
    components:{FontAwesomeIcon},
    props:{
      reservation:{
        required: true,
        type: Object,
      },
      update: {
        required: true
      }
    },
    data() {
      return {
        errors: [],
        items: [],
        loading: true
      }
    },
    mounted() {
      this.getHistory()
    },
    methods:{
      getHistory() {
        const url = `${process.env.MIX_APP_URL}/reservations/${this.reservation.id}/history`
        this.$axios.get(url).then(rs => {
          this.loading = false
          this.items = rs.data
        })
        .catch(error => {
          this.loading = false
          this.errors = [
            {message: 'No se pudo cargar el hitorial'}
          ]
        })
      },
      getTextVariant(item) {
        if (item.type == 'modification') {
          return 'white'
        }
        return ''
      },
      getBgVariant(item) {
        if (item.type == 'modification') {
          return 'info'
        }
      },
      getTitle(item) {
        if (item.type == 'modification') {
          return 'Modificación'
        }
      },
      getFieldText(field) {
        switch(field) {
          case 'special_request': 
            return 'Observaciones';
          case 'address': 
            return 'Dirección';
          case 'currency': 
            return 'Moneda';
          case 'currency': 
            return 'Moneda';
          default: 
            return field
        }
      }
    },
    watch: {
      update() {
        console.log('lalaal');
        
        this.loading = true
        this.getHistory()
      }
    }
  }
</script>